import { render, staticRenderFns } from "./Rings.vue?vue&type=template&id=bc010eca&"
import script from "./Rings.vue?vue&type=script&lang=js&"
export * from "./Rings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports